import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/20/solid";

function Message({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-md bg-green-50 p-4 flex justify-center items-center">
      <div className="flex">{children}</div>
    </div>
  );
}

export function Success({ children }: { children: React.ReactNode }) {
  return (
    <Message>
      <div className="flex-shrink-0">
        <CheckCircleIcon
          className="h-5 w-5 text-green-400"
          aria-hidden="true"
        />
      </div>
      <div className="ml-3">
        <p className="text-sm font-medium text-green-800">{children}</p>
      </div>
    </Message>
  );
}

export function Error({ children }: { children: React.ReactNode }) {
  return (
    <Message>
      <div className="flex-shrink-0">
        <ExclamationTriangleIcon
          className="h-5 w-5 text-yellow-400"
          aria-hidden="true"
        />
      </div>
      <div className="ml-3">
        <h3 className="text-sm font-medium text-yellow-800">
          Attention needed
        </h3>
        <div className="mt-2 text-sm text-yellow-700">
          <p>{children}</p>
        </div>
      </div>
    </Message>
  );
}
